module.exports = __webpack_public_path__ + "img/blue.338fb364.jpg";